import React from 'react';
import { SmartphoneIcon, ClockIcon, TrendingUpIcon, HeartHandshakeIcon } from 'lucide-react';
export function ProductFeatures() {
  const features = [{
    icon: SmartphoneIcon,
    title: 'Solo tu celular',
    description: 'Sin computadora ni equipo costoso. Todo desde tu teléfono en 1-2 horas al día.'
  }, {
    icon: ClockIcon,
    title: 'A tu ritmo',
    description: 'Trabaja cuando quieras: mientras los niños duermen o en tu hora libre.'
  }, {
    icon: TrendingUpIcon,
    title: 'Paso a paso',
    description: 'Sistema exacto: haz esto, luego esto. Imposible perderte.'
  }, {
    icon: HeartHandshakeIcon,
    title: 'Comunidad activa',
    description: 'Grupo privado con 2,000+ mujeres que comparten tips y resultados.'
  }];
  return <section className="section-spacing bg-gradient-premium" data-id="element-461">
      <div className="container-premium" data-id="element-462">
        <div className="text-center mb-10" data-id="element-463">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-deep-cocoa mb-3" data-id="element-464">
            ¿Por qué 2,347 mujeres eligieron esto?
          </h2>
          <p className="text-base text-deep-cocoa/70" data-id="element-465">
            Simple, directo y funciona. Sin complicaciones.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-466">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <div key={index} className="bg-white rounded-xl p-5 shadow-soft animate-fade-in-up" style={{
            animationDelay: `${index * 100}ms`
          }} data-id="element-467">
                <div className="w-12 h-12 bg-gradient-to-br from-cta-primary/10 to-cta-secondary/10 rounded-lg flex items-center justify-center mb-3" data-id="element-468">
                  <Icon className="w-6 h-6 text-cta-primary" data-id="element-469" />
                </div>
                <h3 className="text-base font-bold text-deep-cocoa mb-2" data-id="element-470">
                  {feature.title}
                </h3>
                <p className="text-sm text-deep-cocoa/70 leading-relaxed" data-id="element-471">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}